import {booleanAttribute, Component, computed, inject, input, model, Optional, viewChild} from '@angular/core';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {SidenavService} from '@app-layout/sidenav/data-access';
import {TranslateModule} from '@ngx-translate/core';
import {BadgeComponent} from '@shared/badge';
import {SidenavItemsGroupComponent} from '../sidenav-items-group/sidenav-items-group.component';

import {toSignal} from '@angular/core/rxjs-interop';

@Component({
	selector: 'dc-sidenav-item',
	exportAs: 'dcSidenavItem',
	imports: [TranslateModule, RouterLink, RouterLinkActive, BadgeComponent],
	templateUrl: './sidenav-item.component.html',
	styleUrls: ['./sidenav-item.component.scss'],
})
export class SidenavItemComponent {
	protected readonly isNaN = isNaN;

	// Services
	protected readonly routerLinkActive = viewChild(RouterLinkActive);
	private readonly sidenavService = inject(SidenavService);
	private readonly router = inject(Router);
	// Inputs
	public readonly id = input.required<string>();
	public readonly label = input.required<string>();
	public readonly icon = input<string>();
	public readonly route = input<string>();
	public readonly path = input<string>();
	public readonly command = input<() => void>();
	public readonly isPwaOnly = input(false, {transform: booleanAttribute});

	public readonly counterKey = model<string | undefined>(undefined);
	public readonly counterValue = model<number>(NaN);

	// Signals
	private readonly routerEvents = toSignal(this.router.events);

	protected readonly isSidenavCollapsed = computed(() => this.sidenavService.collapsed());
	public readonly isActive$ = computed(() => {
		if (this.route()) return this.routerEvents() && this.routerLinkActive()?.isActive;
		if (this.path()) {
			return location.pathname.includes(this.path());
		}
	});

	constructor(@Optional() public readonly parentGroup: SidenavItemsGroupComponent) {}

	protected handleClick(event: MouseEvent): void {
		if (this.command()) {
			event.preventDefault();
			this.command()();
		}
	}
}
